import { render } from "./ListaSottoProgetti.vue?vue&type=template&id=5e64dbda&ts=true"
import script from "./ListaSottoProgetti.vue?vue&type=script&lang=ts"
export * from "./ListaSottoProgetti.vue?vue&type=script&lang=ts"

import "./ListaSottoProgetti.vue?vue&type=style&index=0&id=5e64dbda&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__